import { post, put, get } from "../../helpers/apihelpers";

export const CreateClientAssignTimeService=async(data)=>{
    try {
        const result = await post(`api/admin/client_assign_time/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClientAssignTimeService=async(data,id)=>{
    try {
        const result = await put(`api/admin/client_assign_time/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClientAssignTimeService = async ()=>{
  try {
    const result = await get(`api/admin/client_assign_time/get`);
    return result;
  } catch (err) {
    return err.response;
  }
}